// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2K6dW","empty":"ModalGraph_empty__kd0j_"};